import"../../focus/md-focus-ring.js";import"../../ripple/ripple.js";import"../../../../../../@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{nothing as t,html as r}from"../../../../../../lit-html@3.2.1/node_modules/lit-html/lit-html.js";import"../../../../../../lit-element@4.1.1/node_modules/lit-element/lit-element.js";/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */function c({ariaLabel:e,disabled:i,focusListener:n,tabbable:a=!1}){return r`
    <span id="remove-label" hidden aria-hidden="true">Remove</span>
    <button
      class="trailing action"
      aria-label=${e||t}
      aria-labelledby=${e?t:"remove-label label"}
      tabindex=${a?t:-1}
      @click=${o}
      @focus=${n}>
      <md-focus-ring part="trailing-focus-ring"></md-focus-ring>
      <md-ripple ?disabled=${i}></md-ripple>
      <span class="trailing icon" aria-hidden="true">
        <slot name="remove-trailing-icon">
          <svg viewBox="0 96 960 960">
            <path
              d="m249 849-42-42 231-231-231-231 42-42 231 231 231-231 42 42-231 231 231 231-42 42-231-231-231 231Z" />
          </svg>
        </slot>
      </span>
      <span class="touch"></span>
    </button>
  `}function o(e){this.disabled||this.softDisabled||(e.stopPropagation(),!this.dispatchEvent(new Event("remove",{cancelable:!0})))||this.remove()}export{c as renderRemoveButton};
